export default {
  computed: {
    settings() {
      let power = this.$store.getters['types/chosenProperty']('powers', this.$store.state.build.power);

      return (power && power.settings.length > 0) ? power.settings.map((c) => {
        return {id: c.id, label: c.name, value: c.id}
      }) : [];
    },
  },
  methods: {
    updateSetting() {
      const settingId = this.settings[0].id;
      this.$store.dispatch('build/changeSetting', {value: settingId})
    }
  }
}
